<template>
  <div class="page home">
    <div class="home-swiper" v-if="!intro">
      <swiper :options="swiperOption" ref="homeSwiper">
        <swiper-slide v-for="(pic, index) in swiperPics" :key="index">
          <img :src="pic">
        </swiper-slide>
      </swiper>
    </div>
    <div class="btn-dialog btn-dialog-show" @click="intro = true">{{ $t("page.home-intro") }}</div>
    <transition name="slide-fade">
      <div class="intro-wrapper" v-if="intro">
        <div class="main-intro">
          <div class="intro-title">
            <img src="img/home/home-intro-tt.png">
          </div>
          <m-textarea>
            <div v-html="content"></div>
          </m-textarea>
          <div class="btn-dialog" @click="intro = false">{{ $t("base.pack-up") }}</div>
        </div>
      </div>
    </transition>
    
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TextArea from "@/components/TextArea.vue";
export default {
  components: {
    "m-textarea": TextArea
  },
  data() {
    return {
      intro: false,
      swiperOption: {
        autoplay: true,
        loop: true,
        slidesPerView: "auto",
        loopedSlides: 6,
        slidesOffsetBefore: (window.innerWidth * 12) / 100,
        followFinger: false,
        disableOnInteraction: false
      },
      swiperPics: [
        "img/home/1-chuozi.png",
        "img/home/2-qiuzi.png",
        "img/home/3-toucha.png",
        "img/home/4-chenjing.png",
        "img/home/5-daoju.png",
        "img/home/6-dongwu.png"
      ]
    };
  },
  computed: {
    ...mapState(["home", "locale"]),
    content() {
      return this.home.intro.content;
    }
  },
  mounted() {
    this.getContent({
      page: "home",
      tab: "intro"
    });
  },
  watch: {
    locale(newLocale, oldLocale) {
      if (newLocale != oldLocale) {
        this.getContent({
          page: "home",
          tab: "intro"
        });
      }
    }
  },
  methods: {
    ...mapActions(["getContent"])
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.home-swiper {
  padding-top: 2rem;

  .swiper-container {
    overflow: visible;
  }

  .swiper-slide {
    width: 90vw;
    height: 70vh;
    text-align: center;
    margin: 0 -2rem;

    img {
      max-height: 100%;
      max-width: 90vw;
      transform: scale(0.75);
      transform-origin: center center;
      filter: blur(10px);
      opacity: 0.6;
      transition: all 0.6s;
    }
  }

  .swiper-slide-active {
    z-index: 10;
    img {
      transform: scale(1);
      filter: blur(0px);
      opacity: 1;
    }
    &::after {
      content: "";
      position: absolute;
      display: block;
      bottom: 0;
      width: 100%;
      height: 2rem;
      background-image: url("~@/assets/img/swiper-active.png");
    }
  }
}

.btn-dialog {
  bottom: 1rem;
}
.intro-wrapper {
  position: relative;
  height: 100%;
}
.main-intro {
  @include full-box;
  z-index: 50;
  height: 100%;
  padding-top: 2rem;
  padding-left: 1.5rem;
  padding-right: 2rem;
  background-image: url("~@/assets/img/dialog-bg.jpg");

  .intro-title {
    position: absolute;
    display: block;
    @include scaleimg(0.5);
  }

  .textarea {
    height: 70vh;
  }

  .text-main {
    padding-left: 5rem;
    padding-right: 1rem;
    font-size: 0.875rem;

    p {
      margin-top: 0;
    }
  }
}
</style>
